'use client';

// French copy of components/supportedPlatforms (FR-1). Fallback when a
// hub has no platform carousel tiles.

import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import Link from 'next/link';
import React from 'react';
import { CSSProperties } from 'styled-components';
import { CustomLink } from '../link/link.comp';
import {
    DEFAULT_PLATFORM_TILES,
    IPlatformTile,
} from '../widgetPlatformCarousel/widgetPlatformCarousel.data';
import { EnTag } from './langSwitch.comp';
import { StyledDiv } from '../supportedPlatforms/supportedPlatforms.styles';

export const SupportedPlatformsFr = ({ style = {} }: { style?: CSSProperties; }) => {
    const renderTile = (p: IPlatformTile) => (
        <Link
            key={p.slug}
            href={`/platforms/${p.slug}`}
            className="tile"
            aria-label={`Plateforme ${p.name} (en anglais)`}
            hrefLang="en"
            title={p.name}
        >
            <svg
                className="icon"
                role="img"
                viewBox="0 0 24 24"
                width="44"
                height="44"
                fill={`#${p.iconHex}`}
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
            >
                <path d={p.iconPath} />
            </svg>
        </Link>
    );

    return (
        <StyledDiv style={style}>
            <h2>Compatible avec tous les créateurs de sites, plateformes e-commerce et sites web</h2>
            <div className="companies-wrapper">
                {DEFAULT_PLATFORM_TILES.map(renderTile)}
            </div>
            <CustomLink className='show-more' href='/platforms' title='Voir toutes les plateformes compatibles'>Voir toutes les plateformes compatibles <EnTag />
                <IoIosArrowForward className='icon' />
            </CustomLink>
        </StyledDiv>
    );
};
